import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export type CompareBlockComparisonType = "JSON" | "NUMBER" | "STRING";

const comparisonTypeHumanReadable: Record<CompareBlockComparisonType, string> = {
  STRING: "Simple String (==)",
  NUMBER: "Number",
  JSON: "JSON Path",
};

interface ComparisonTypeSelectorProps {
  comparisonType: CompareBlockComparisonType | undefined;
  onComparisonTypeChange: (type: CompareBlockComparisonType) => void;
  disabled?: boolean;
}

const ComparisonTypeSelector = ({
  comparisonType,
  onComparisonTypeChange,
  disabled = false,
}: ComparisonTypeSelectorProps) => (
  <Select
    value={comparisonType || undefined}
    onValueChange={onComparisonTypeChange}
    disabled={disabled}
  >
    <SelectTrigger className="w-full">
      <SelectValue placeholder="Select a comparison type..." />
    </SelectTrigger>
    <SelectContent>
      {(["STRING", "NUMBER", "JSON"] as const).map(type => (
        <SelectItem key={type} value={type}>
          {comparisonTypeHumanReadable[type]}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);

export default ComparisonTypeSelector;
